<div class="mt-6 overflow-hidden rounded-md border border-zinc-100 shadow shadow-slate-200 xl:mt-8">
  <div class="flex h-16 items-center border-b border-zinc-100 px-6 py-2">
    <div class="flex-1 uppercase">{{ 'profile.subscription.headline' | transloco }}</div>
  </div>

  <div class="truncate bg-zinc-50 px-6 pb-12 pt-8">
    <!-- Subscription -->
    <div>
      <h4 class="font-bold">{{ 'profile.subscription.title' | transloco }}</h4>
      <p class="mt-2">
        @if (userHasSubscription()) {
          <span
            class="mr-2 inline-block rounded-md border px-3 py-1 text-sm uppercase subpixel-antialiased"
            [ngClass]="{
              'border-black bg-black text-white': userSubscription() === 'professional',
              'border-black bg-yellow-500 text-black': userSubscription() === 'enterprise',
              'border-black text-black': userSubscription() === 'trial',
            }">
            {{ subscriptionKey() | transloco }}
          </span>

          @if (userSubscription() === 'trial' && trialLeftDays() !== undefined) {
            @if ((trialLeftDays() ?? 0) < 1) {
              <span class="text-red-500">{{ 'profile.subscription.trialExceeded' | transloco }}</span>
            }

            @if ((trialLeftDays() ?? 0) > 0) {
              @if ((trialLeftDays() ?? 0) === 1) {
                {{ 'profile.subscription.dayLeft' | transloco }}
              } @else {
                {{ 'profile.subscription.daysLeftPlural' | transloco: { days: trialLeftDays() } }}
              }
            }
          }

          @if (userHasSubscription() && userSubscription() !== 'trial' && subscriptionLeftDays() !== undefined) {
            @if ((subscriptionLeftDays() ?? 0) < 1) {
              <span class="text-red-500">{{ 'profile.subscription.subscriptionExceeded' | transloco }}</span>
            }

            @if ((subscriptionLeftDays() ?? 0) > 0) {
              @if ((subscriptionLeftDays() ?? 0) === 1) {
                {{ 'profile.subscription.dayLeft' | transloco: { days: subscriptionLeftDays() } }}
              } @else {
                {{ 'profile.subscription.daysLeftPlural' | transloco: { days: subscriptionLeftDays() } }}
              }
            }
          }
        }
      </p>

      <div class="mt-6">
        @if (userHasSubscription() && userSubscription() === 'professional') {
          <!-- Upgrade link (goes to stripe customer portal) -->
          @if (customerPortalLink()) {
            <a
              [attr.href]="customerPortalLink()"
              pButton
              target="_blank"
              rel="noopener noreferrer"
              disabled="!customerPortalLink() || !authService.userIsAdmin()">
              <span pButtonLabel>{{ 'profile.subscription.btnUpgrade' | transloco }}</span>
            </a>
          } @else {
            <a [attr.href]="concactUrl" target="_blank" pButton>
              <span pButtonLabel>{{ 'profile.subscription.btnUpgrade' | transloco }}</span>
            </a>
          }
        } @else if (userHasSubscription() && userSubscription() === 'enterprise') {
          <a [attr.href]="concactUrl" target="_blank" pButton severity="contrast" variant="outlined" class="p-button-outlined">
            <span pButtonLabel>{{ 'profile.subscription.btnContact' | transloco }}</span>
          </a>
        } @else {
          <!-- Buy link (opens stripe product popup) -->
          <p-button [label]="'profile.subscription.btnBuy' | transloco" (onClick)="openProductList()" [disabled]="!authService.userIsAdmin()" />
        }
      </div>

      <!-- <div class="mt-6 flex border border-primary-500">
        @for (item of subscriptionProducts(); track $index) {
          <div class="flex flex-col items-start justify-start gap-4">
            <h3>{{ item.name }}</h3>
            <p>Preis: {{ item.price | price: item.currency }}</p>
            <ul class="ml-4 list-disc pr-4">
              <li *ngFor="let feature of item.marketingFeatures">
                {{ feature.name }}
              </li>
            </ul>
          </div>
        }
      </div> -->
    </div>

    <!-- Used Cases (temporary hidden until CB-989) -->
    <!-- <div class="mt-8">
      <h4 class="font-bold">{{ 'profile.subscription.cases.title' | transloco }}</h4>
      <div class="mt-1 inline-flex items-center justify-center gap-4">
        <app-progress-bar
          class="w-[200px] pt-4"
          [value]="user()?.subscription?.usedCases ?? 0"
          [max]="user()?.subscription?.availableCases ?? 100"
          labelKey="profile.subscription.cases.label" />
      </div>
    </div>-->
  </div>
</div>
